// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingShadeTile_loading__1nV5N"};